import { render, staticRenderFns } from "./product_7_jgw.vue?vue&type=template&id=5346c6a6&scoped=true"
import script from "./product_7_jgw.vue?vue&type=script&lang=js"
export * from "./product_7_jgw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346c6a6",
  null
  
)

export default component.exports